import qs from 'qs';
import React from 'react';
import { Link } from 'react-router-dom';
import request from '../../../request';

export default class Staff extends React.Component {
  constructor() {
    super();
    this.state = {
      users: JSON.parse(localStorage.getItem('staff')) || { data: [] },
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(nextProps) {
    if (nextProps.location.search !== this.props.location.search) this.load();
  }

  async load() {
    let { location } = this.props;
    let query = qs.parse(location.search.substring(1));
    let page = query.page || 1;

    try {
      if (this.state.users.data.length === 0) this.setState({ loading: true });
      let users = await request({ url: `admin/admin?page=${page}` });
      localStorage.setItem('staff', JSON.stringify(users));
      this.setState({ users, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  render() {
    let { location } = this.props;
    let { users, loading } = this.state;

    let query = qs.parse(location.search.substring(1));
    let page = parseInt(query.page || 1, 10);
    return (
      <div style={{ opacity: loading ? 0.5 : 1 }}>
        <table>
          <thead>
            <tr>
              <th className="last">Last Name</th>
              <th className="first">First Name</th>
              <th className="email">Email</th>
              <th className="status">Status</th>
              <th className="actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.data.map(user => (
              <tr key={user.id}>
                <td className="last">{user.last_name}</td>
                <td className="first">{user.first_name}</td>
                <td className="email">{user.email}</td>
                <td className="status">{user.status}</td>
                <td className="actions">
                  <Link to={`/settings/users/user/${user.id}`}>Edit</Link>
                  {' '}
                  ·
                  {' '}
                  <Link
                    to={{
                      pathname: `/settings/users/user/${user.id}/delete`,
                      state: { user },
                    }}
                  >
                    Delete
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {users.prev_page_url
          ? <Link
              className="prev-button"
              to={`/settings/users?page=${page - 1}`}
            >
              Previous Page
            </Link>
          : null}

        {users.next_page_url
          ? <Link
              className="next-button"
              to={`/settings/users?page=${page + 1}`}
            >
              Next Page
            </Link>
          : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/users/all.js